import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signup.css';
import iconBack from '../../assets/images/icon-back.svg';

interface LocationState {
  snsType?: string;
  snsId?: string;
  email?: string;
  name?: string;
  phone?: string;
}

const Carrier: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const [carrier, setCarrier] = useState<string | null>(null);

  const handleNext = () => {
    if (carrier) {
      navigate('/signup/gender', {
        state: {
          ...state,
          carrier
        }
      });
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <button className="back-button" onClick={handleBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="signup-content">
        <div className="signup-inner">
          <div className="signup-form">
            <div className="signup-title-section">
              <h1 className="signup-title">
                본인 휴대폰의 통신사를
                <br />
                선택해 주세요.
              </h1>
            </div>

            <div className="carrier-grid">
              <button
                className={`carrier-btn ${carrier === 'SKT' ? 'selected' : ''}`}
                onClick={() => setCarrier('SKT')}
              >
                SKT
              </button>
              <button
                className={`carrier-btn ${carrier === 'KT' ? 'selected' : ''}`}
                onClick={() => setCarrier('KT')}
              >
                KT
              </button>
              <button
                className={`carrier-btn ${carrier === 'LG' ? 'selected' : ''}`}
                onClick={() => setCarrier('LG')}
              >
                LGU+
              </button>
              <button
                className={`carrier-btn ${carrier === '알뜰폰' ? 'selected' : ''}`}
                onClick={() => setCarrier('알뜰폰')}
              >
                알뜰폰
              </button>
            </div>
          </div>

          <div className="signup-footer">
            <div className="spacer"></div>
            <button
              className={`signup-btn ${carrier ? 'active' : ''}`}
              onClick={handleNext}
              disabled={!carrier}
            >
              다음
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carrier;
